import React, { useEffect, useState } from 'react'
import { vanSubsTransactions } from '../../actions/VanSubscription';
import moment from 'moment';

const VanSubscriptionTransactions = ({currentDate,endDate,subscriptionDetail}) => {
    const [transactionList,setTransactionList] = useState([]);

    function calculateRemainingDays(endDate) {
        const currentTime = new Date();
        const endDateNewDate = new Date(endDate);
        const remainingTime = endDateNewDate - currentTime;
        return remainingTime > 0 ? Math.ceil(remainingTime / (1000 * 60 * 60 * 24)) : 0;
    }


    useEffect(() => {
        const fetchTransactionList = async () => {
            const response = await vanSubsTransactions();
            setTransactionList(response?.transaction_list)
        }
        fetchTransactionList()
    },[])

  return (
    <div className='van_subscription_transactions mt-3 mb-5'>
        <h5 className='mb-3 fw-bold text-primary justify-content-center d-flex align-items-center' style={{gap:'14px'}}>Transactions  
            {/* <small className='text-info fs-6 fw-regular'> ( {currentDate>endDate ? `Plan Expired on ${endDate}` : `${calculateRemainingDays(endDate)} Days Left  | Expiring On ${moment(endDate).format('DD-MM-YYYY')}`})</small> */}
            </h5>
        <div className="table-responsive">
            <table className="table border table-striped">
                <thead className='bg-primary text-white'>
                    <tr>
                        <th>S.R</th>
                        <th>Paid On</th>
                        <th>Payment Type</th>
                        <th>Paid Amount</th>
                        <th>Payment Mode</th>
                        <th>Status</th>
                        <th>Payment Receipt</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        transactionList.map((item,index) => {
                            const months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

                            return(
                                <tr key={index}>
                                    <td>{index+1}</td>
                                    <td>{moment(item.transaction_date).format('DD-MM-YYYY') || 'NA'}</td>
                                    <td> {item.subscription_type ===100?'Lumpsum':'installment'}</td>
                                    <td>{item.paid_amount} AED</td>
                                    <td>{(item.offline_transaction_id===null || item.offline_transaction_id===0)?'Online':'Offline'}</td>
                                    <td>{item?.verified === 1 && 'Approved'} {item?.verified === 2 && 'Rejected'} {item?.verified === 0 && 'Approval Pending'}</td>
                                    <td>{item.acknowledgement_receipt ? <a href={item.acknowledgement_receipt} target='_blank' rel="noreferrer" download className='badge py-2 bg-secondary text-white text-decoration-none rounded' title='Download Receipt'>
                                        <svg xmlns="http://www.w3.org/2000/svg" style={{width:'12px',marginRight:'4px',marginTop:'-3px'}} width="12" height="12" fill="currentColor" className="bi bi-download" viewBox="0 0 15 15">
                                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
                                        </svg>
                                         Receipt
                                    </a> : 'NA'}</td>
                                </tr>
                            )
                        })
                    }
                    {transactionList.length ===0 && (<tr><td style={{textAlign:'center',fontWeight:'600'}} colSpan={7}>Loading...</td></tr>)}
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default VanSubscriptionTransactions